<template>
  <div class="main-wrapper-container">
    <header-title :main-title="mainTitle" :btn-info="btnInfo" />

    <div class="partners-container">
      <div class="partner-card" v-for="item in partners" :key="item.id">
        <icon-default
          class="partner-icon-edit"
          @click="editPartner(item)"
          title="Редактировать"
          :color="'dark-green'"
        >
          <IconEdit />
        </icon-default>
        <icon-default
          class="partner-icon-delete"
          @click="openModalDeletePartner(item)"
          title="Удалить"
          :color="'dark-green'"
        >
          <IconDelete />
        </icon-default>
        <v-img
          v-if="item.logoKey"
          :src="getS3Key(item.logoKey)"
          max-width="300"
          max-height="300"
          contain
        />
        <div class="partner-url">
          {{ item.url }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderTitle from "@/components/entities/HeaderTitle.vue";
import { mapActions, mapState } from "vuex";
import IconEdit from "@/assets/icons/ui/edit.svg?inline";
import IconDelete from "@/assets/icons/ui/delete.svg?inline";
import IconDefault from "@/components/shared/icons/IconDefault.vue";
import modalAgreement from "@/mixins/modals/modalAgreement";
import { api } from "@/middleware/api";

export default {
  components: { IconDefault, IconDelete, IconEdit, HeaderTitle },
  mixins: [modalAgreement],
  name: "PartnersPage",
  data() {
    return {
      mainTitle: "Партнеры",
      btnInfo: {
        text: "Добавить партнера",
        action: () => this.openCreatePartners(),
      },
    };
  },
  computed: {
    ...mapState("partners", ["partners"]),
  },
  async created() {
    await this.fetchInfo();
  },
  methods: {
    ...mapActions("partners", ["deletePartner", "fetchPartners"]),
    async fetchInfo() {
      try {
        this.IS_GLOBAL_LOADING(true);
        await this.fetchPartners();
      } catch (e) {
      } finally {
        this.IS_GLOBAL_LOADING(false);
      }
    },
    editPartner(item) {
      this.$router.push({
        name: "partners-edit",
        params: { id: item.id },
      });
    },
    openCreatePartners() {
      this.$router.push({
        name: "partners-create",
      });
    },
    removePartner(item) {
      this.deletePartner(item.id);
    },
  },
};
</script>

<style scoped lang="scss">
.partners-container {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  .partner-card {
    display: flex;
    width: 300px;
    height: 345px;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    .v-img {
      border-radius: 12px;
      border: 1px solid rgba(var(--color-grey-rgba, 1));
    }
    .partner-icon-delete {
      position: absolute;
      z-index: 1;
      right: 8px;
      top: 8px;
      cursor: pointer;
      background: rgba(var(--color-grey-rgba, 1));
      border-radius: 6px;
    }
    .partner-icon-edit {
      position: absolute;
      z-index: 1;
      right: 40px;
      top: 8px;
      cursor: pointer;
      background: rgba(var(--color-grey-rgba, 1));
      border-radius: 6px;
    }
    .partner-url {
      width: 100%;
      border: 1px solid rgba(var(--color-grey-rgba), 1);
      border-radius: 12px;
      padding: 8px 16px;
      color: var(--color-dark-green);
      font-size: 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
